import {CssTheme} from '@ui/themes/css-theme';

export function getThemeLogo(
  theme?: CssTheme | null,
  isDarkMode?: boolean,
): string | undefined {
  const preferDarkLogo = isDarkMode ?? getDocumentIsDarkMode() ?? theme?.is_dark;
  const darkLogo = getThemeValue(theme, '--be-logo-dark');
  const lightLogo = getThemeValue(theme, '--be-logo-light');

  if (preferDarkLogo) {
    return darkLogo || lightLogo || undefined;
  }

  return lightLogo || darkLogo || undefined;
}

function getThemeValue(
  theme: CssTheme | null | undefined,
  key: '--be-logo-dark' | '--be-logo-light',
): string | undefined {
  const values = theme?.values ?? {};
  const legacyColors = (
    theme as (CssTheme & {colors?: Record<string, string>}) | null | undefined
  )?.colors ?? {};

  return values[key] || legacyColors[key] || getRootThemeValue(key);
}

function getRootThemeValue(
  key: '--be-logo-dark' | '--be-logo-light',
): string | undefined {
  if (typeof window === 'undefined') return undefined;

  const value = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(key)
    .trim();

  return value || undefined;
}

function getDocumentIsDarkMode(): boolean | undefined {
  if (typeof document === 'undefined') return undefined;

  const root = document.documentElement;
  const dataTheme = root.getAttribute('data-theme');
  if (dataTheme === 'dark') return true;
  if (dataTheme === 'light') return false;

  return root.classList.contains('dark');
}
